export const disableContextMenu = (event) => {
   event.preventDefault();
  };